/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { BORDER_RADIUS_SM } from "../../theme/theme";

export default function ConfirmSeatDialog({
  confirmSeatModal,
  setConfirmSeatModal,
  userForms,
  proratedAmount,
  confirmSeatModalError,
  confirmSeatLoading,
  handleConfirmSeatAddition,
}: any) {
  const manualCount = userForms.filter((e) => e.manualPassword).length;
  const inviteCount = userForms.filter((e) => !e.manualPassword).length;
  const planLabel = proratedAmount?.billingInterval === "year" ? "Yearly" : "Monthly";
  const currency = proratedAmount?.currency?.toUpperCase() ?? "";
  const rawAmount = proratedAmount ? Math.abs(proratedAmount.amount) : 0;
  const fetchedCount = proratedAmount?.count || userForms.length || 1;
  const perSeat = rawAmount / fetchedCount;
  const manualAmountStr = `${(perSeat * manualCount).toFixed(2)} ${currency}`;
  const perSeatStr = `${perSeat.toFixed(2)} ${currency}`;
  const inviteAmountStr = `${(perSeat * inviteCount).toFixed(2)} ${currency}`;

  return (
    <Dialog
      open={confirmSeatModal}
      onClose={() => setConfirmSeatModal(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Confirm Seat Addition</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, pt: 0.5 }}>
          {manualCount > 0 && (
            <Alert severity="warning" icon={false} sx={{ borderRadius: BORDER_RADIUS_SM }}>
              <Typography variant="body2" fontWeight={600} gutterBottom>
                💳 {manualCount} user{manualCount !== 1 ? "s" : ""} — admin-set password (charged immediately)
              </Typography>
              <Typography variant="body2">
                {manualCount === 1
                  ? "This user will be created instantly and can log in right away."
                  : `These ${manualCount} users will be created instantly and can log in right away.`}{" "}
                Your subscription will increase from{" "}
                <strong>{proratedAmount?.currentUsers}</strong> to{" "}
                <strong>{proratedAmount?.newQuantity}</strong> seats.
                A prorated charge of <strong>{manualAmountStr}</strong>
                {manualCount > 1 ? ` (${perSeatStr} × ${manualCount} seats)` : ""} will be
                applied to your card <strong>immediately</strong>, covering the
                remaining days in this {planLabel.toLowerCase()} billing cycle.
              </Typography>
            </Alert>
          )}
          {inviteCount > 0 && (
            <Alert severity="info" icon={false} sx={{ borderRadius: BORDER_RADIUS_SM }}>
              <Typography variant="body2" fontWeight={600} gutterBottom>
                ✉️ {inviteCount} user{inviteCount !== 1 ? "s" : ""} — invite link (charged on acceptance)
              </Typography>
              <Typography variant="body2">
                An invitation email will be sent to{" "}
                {inviteCount === 1 ? "this user" : `these ${inviteCount} users`} to set their own
                password and join the organisation. <strong>No charge now</strong> —
                once {inviteCount === 1 ? "they accept" : "each user accepts"} and their account
                becomes active, a prorated charge of{" "}
                <strong>{inviteCount > 1 ? `${perSeatStr} per seat (${inviteAmountStr} total)` : perSeatStr}</strong> will
                be applied at that time based on the remaining days in the billing cycle.
              </Typography>
            </Alert>
          )}
        </Box>
        {confirmSeatModalError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {confirmSeatModalError}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmSeatModal(false)} disabled={confirmSeatLoading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirmSeatAddition}
          disabled={confirmSeatLoading}
          startIcon={confirmSeatLoading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {confirmSeatLoading ? "Processing…" : "Confirm & Pay"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
